import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// actions + utils
import { loadAllShoppers } from '../../actions/shopper';
import { castDirectionToBool } from '../../common/utils/cast';

// components
import UserTable from './UserTable';
import TableFilters from './TableFilters';
import SelectedLeadsModal from './SelectedLeadsModal';
import SelectAgentModal from '../common/SelectAgentModal';
import LeadDetailsModal from './LeadDetailsModal';

function OpenModalButton() {
  const dispatch = useDispatch();
  const { selectedLeads = [] } = useSelector(store => store.leads);
  const selectedLeadsCount = selectedLeads.length;

  return (
    <div
      style={{
        position: 'fixed',
        right: '0px',
        bottom: '0px',
        height: '40px',
        width: '300px',
        top: '0px',
        zIndex: 9,
        transform: 'rotate(-0.25turn)',
        transformOrigin: 'bottom right',
      }}
    >
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'selectedLeadsModal' })}
      >
        <span className="me-2 badge rounded-pill bg-primary">
          {selectedLeadsCount}
        </span>
        Selected Leads
      </button>
    </div>
  );
}

function Leads() {
  const dispatch = useDispatch();
  const [ loading, setLoading ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState('');

  const {
    searchTerm: storeSearchTerm,
    sortTerm: storeSortTerm,
    sortInverse: storeSortInverse,
    activePage,
    selectedLeads = [],
    agentFilter = {},
    dispositionFilter: storeDispositionFilter,
  } = useSelector(store => store.leads);

  function handleLoadShoppers({
    sortTerm = storeSortTerm,
    sortInverse = storeSortInverse,
    page = activePage,
    searchTerm = storeSearchTerm,
    agentUsername = (agentFilter.username || '*'),
    dispositionFilter = storeDispositionFilter,
  } = {}) {
    setLoading(true);
    setErrorMessage('');
    loadAllShoppers({
      desc: castDirectionToBool(sortInverse),
      sortTerm,
      page,
      searchTerm,
      agentUsername,
      dispositionFilter: (dispositionFilter || undefined),
    })
      .then((data) => dispatch({ type: 'LOAD_LEADS_LIST', payload: data }))
      .catch(() => setErrorMessage('Error loading shoppers'))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    dispatch({ type: 'CLEAR_LEADS_REDUCER' });
    handleLoadShoppers();
  }, []);

  return (
    <>
      {/* <SelectedUserSideBar /> */}
      <main className="p-5">
        <div className="row">
          <div className="col">
            <h2 className="mb-3 fw-bold">Lead Administration</h2>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="border bg-white pt-4 h-100 shadow-sm">
              <div className="row mb-4 px-3">
                <TableFilters handleLoadShoppers={(args) => handleLoadShoppers(args)} />
              </div>

              <hr />

              <div className="row">
                <div className="col">
                  <UserTable
                    loading={loading}
                    errorMessage={errorMessage}
                    handleLoadShoppers={(args) => handleLoadShoppers(args)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {selectedLeads.length && (
        <OpenModalButton />
      )}
      <SelectedLeadsModal handleLoadShoppers={(args) => handleLoadShoppers(args)} />
      <LeadDetailsModal />
      <SelectAgentModal
        handleAgentSelect={(agent) => {
          dispatch({ type: 'SET_LEADS_KEYS', payload: { agentFilter: agent } });
          handleLoadShoppers({ agentUsername: agent.username });
        }}
      />
    </>
  );
}

export default Leads;
